import { Helpers } from '../../helpers';
import { IBudgetCategoryUnitOfMeasure } from '../../interfaces/ibudget-category-unit-of-measure';
import { BudgetCategory } from '../budget-category';

export class BudgetCategoryUnitOfMeasureBase {
  BudgetCategoryUnitOfMeasureId: number;
  Description: string | null;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  BudgetCategories_BudgetCategoryUnitOfMeasure?: Array<BudgetCategory> | null;

  constructor(item?: IBudgetCategoryUnitOfMeasure) {
    if (item) {

      this.BudgetCategoryUnitOfMeasureId = item.BudgetCategoryUnitOfMeasureId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.BudgetCategories_BudgetCategoryUnitOfMeasure = Helpers.createClassArray(BudgetCategory, item.BudgetCategories_BudgetCategoryUnitOfMeasure);
    }
  }
}